module.exports = __webpack_public_path__ + "static/media/first-page-slide5.11d95219.jpg";